<template>
  <b-modal size="lg" ref="logModal" title="Job log" ok-only>
    <b-table small :items="list" :fields="fields">
      <template #cell(time_stamp)="{ value }">
        {{ value | moment('lll') }}
      </template>
      <template #cell(_user)="{ item }">
        <template v-if="item.admin && item.admin.sfid">
          Admin:

          <router-link :to="getURL(item)" target="_blank" rel="noreferrer">
            {{ item.admin.name }}
          </router-link>
        </template>
        <template v-else-if="item.user && item.user.id">
          User:

          <router-link :to="getURL(item)" target="_blank" rel="noreferrer">
            {{ item.user.name }}
          </router-link>
        </template>
      </template>
      <template #cell(_change)="{ item }">
        <template v-if="item.event_type == 'create'">
          Job created - {{ item.source }}
        </template>
        <template v-else-if="item.event_type == 'cancellation'">
          Cancellation reason
        </template>
        <template v-else-if="item.event_type == 'cancellation_clone'">
          Job Cloned by Cancellation reason
        </template>
        <template v-else-if="item.event_type == 'new_status'">
          Status change -
          <strong>{{ statusesById[item.new_status] }}</strong>
        </template>
        <template v-else-if="item.event_type == 'edit'">
          Values updates
        </template>
        <template v-else>Other change</template>
      </template>
      <template #cell(_actions)="row">
        <b-button size="sm" @click.stop="row.toggleDetails">Details</b-button>
      </template>
      <template #row-details="{ item }">
        <b-card no-body>
          <b-tabs pills card>
            <b-tab title="Diff" active>
              <b-card-text>
                <vue-json-compare
                  :oldData="item.old_values"
                  :newData="item.new_values"
                ></vue-json-compare>
              </b-card-text>
            </b-tab>
            <b-tab title="Raw Data">
              <b-card-text>
                <h3>New values</h3>
                <pre style="white-space: pre-wrap">{{ item.new_values }}</pre>
                <h3>Old values</h3>
                <pre style="white-space: pre-wrap">{{ item.old_values }}</pre>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import axios from 'axios';
import VueJsonCompare from 'vue-json-compare';

export default {
  components: {
    VueJsonCompare,
  },
  props: {
    statuses: Array,
    context: String,
    logs: Array,
  },
  data() {
    return {
      list: [],
      fields: [
        { key: 'time_stamp' },
        { key: '_user', title: 'User' },
        { key: '_change', title: 'Change type' },
        { key: '_actions', title: 'Actions' },
      ],
    };
  },
  computed: {
    statusesById() {
      return this.statuses.reduce((statuses, status) => {
        statuses[status.value] = status.text;
        return statuses;
      }, {});
    },
    getURL() {
      return (item) => {
        let entity = '';
        let id = '';

        if (Object.values(item.admin).length) {
          entity = 'Contact';
          id = item.admin.sfid || item.admin.api_id;
        } else {
          entity = `${item.source[0].toUpperCase()}${item.source.slice(1)}`;
          id = item.user.id;
        }

        return `/data-ui/${entity}/${id}`;
      };
    },
  },
  methods: {
    showLog(job_sfid) {
      if (this.context == 'admin') {
        axios
          .get(`/api/${this.context}/jobs/${job_sfid}/log-entries`)
          .then((response) => {
            this.list = response.data;
          });
      } else if (this.context == 'brand') {
        axios
          .get(`/api/${this.context}/orders/${job_sfid}/log-entries`)
          .then((response) => {
            this.list = response.data;
          });
      } else {
        this.list = this.logs;
      }
      this.$refs.logModal.show();
    },
  },
};
</script>
